import "../index.css";

export const Certificate = () => {
	return (
		<div className="side_pad">
			<h1>
				Completed
			</h1>
			<br/>
			<h2>
				<a href="https://coursera.org/share/e72cce09b672732611e668d942d2f9e0" title="Check out my online Certificate from google">Google IT Certificate</a>
			</h2>
			<p>
				The program took a lot of effort and taught so much including
					<li>Technical Support Fundamentals</li>
					<li>The in depth leasons on computer networking</li>
					<li>Operating Systems and got in depth on th CLI on both linux and windows</li>
					<li>Covered many areas of System admin and IT infrustructures and many IT tools and software</li>
					<li>Wide knowledge of Computer security and security protocols and encryption software</li>
			</p>
			<br/>
			<br/>
			<h1>
				In Progress
			</h1>
			<br/>
			<h2>
				Comptia A+ 
				Core 1 has been has been completed next is core 2.
			</h2>
			<p>
				I've been working on my A+ for a while now an am getting comfortable enough to take the exams already scheduled the first one and will soon update hopefully.
			</p>
			<h2>
				<br/>
				Not Started
				<br/>
				Comptia Linux+
				<br/>
				Comptia Network+
			</h2>
		</div>
	);
};
